import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/contact.css';
import { useEffect } from "react";
import axios from 'axios';
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { Formik } from "formik";
import * as Yup from "yup";
import { FiMapPin, FiPhone, FiMail } from "react-icons/fi";


const Contact = () => {

    const { pathname } = useLocation();

    useEffect(() => {
        requestAnimationFrame(() => {
            window.scrollTo({ top: 0, left: 0, behavior: "auto" });
        });
    }, [pathname]);

    // Validation schema
    const schema = Yup.object().shape({
        name: Yup.string().required('Required'),
        contact: Yup.string().required('Required'),
        email: Yup.string().email('Invalid email').required('Required'),
        msg: Yup.string().required('Required'),
    });


    const handleSubmitCheck = (values, { resetForm }) => {
        axios.post(`https://ct-backend-8cr1.onrender.com/add`, values)
            .then((res) => {
                console.log('Submit Response:', res.data);
                // Only if your backend sends a token
                const token = res.data.token;
                if (token) localStorage.setItem('token', token);
                resetForm();
            })
            .catch((error) => {
                console.log('Submit Error:', error);
            });
    };


    return (
        <>
            <div className="contactpage">
                <div className="container-fluid">
                    <h1 className='contacthead'>Contact Us</h1>
                    <div style={{ width: '100%', height: '500px' }} className='map'>
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3719.6227146610013!2d72.8508131!3d21.2071416!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f82ed56468d%3A0x1969f19774e78f36!2sChamunda%20Tailor!5e0!3m2!1sen!2sin!4v1734676536530!5m2!1sen!2sin"
                            width="100%"
                            height="100%"
                            style={{ border: '0', borderRadius: '15px' }}
                            allowfullscreen=""
                            loading="lazy"
                            referrerpolicy="no-referrer-when-downgrade"
                            title="Google Map of San Francisco"
                        ></iframe>
                    </div>
                </div>
                <br /><br />
                <Container fluid className="my-4">
                    <Row gap={4}> {/* Larger gap between columns */}
                        {/* First Child - Sidebar or Content */}
                        <Col
                            xs={12} md={6} lg={6}
                            className="p-5 mb-3 mb-md-0"
                        >
                            <h4>Head Office</h4>
                            <div className="bg-light location-box">
                                <h5>Surat - Gujrat</h5>
                                <p><FiMapPin /><span className='ps-3'>Address</span></p>
                                <p>1, Ramkrushna School bellow, Sivnagar Society, Matawadi, Varachha, Surat - 395006</p>
                                <p><FiPhone /><span className='ps-3'>Lets Talk</span></p>
                                <p>+91 9825928485</p>
                                <p>+91 9979264429</p>
                                <p><FiMail /><span className='ps-3'>Support</span></p>
                                <p>ramparmar480@gmail.com</p>
                            </div>
                        </Col>

                        {/* Second Child - Main Content */}
                        <Col
                            xs={12} md={6} lg={6}
                            className="text-white p-5"
                        >
                            <h4>Connect with us</h4>
                            <div>

                                <Formik
                                    validationSchema={schema}
                                    initialValues={{
                                        name: "",
                                        contact: "",
                                        email: "",
                                        msg: "",
                                    }}
                                    onSubmit={handleSubmitCheck}
                                >
                                    {({ handleSubmit, handleChange, values, errors, touched }) => (
                                        <Form onSubmit={handleSubmit}>

                                            {/* NAME */}
                                            <Form.Group className="mb-3" controlId="formName">
                                                <Form.Label>Your Name</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    placeholder="Full Name"
                                                    value={values.name}
                                                    onChange={handleChange}
                                                    isInvalid={touched.name && !!errors.name}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.name}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            {/* CONTACT */}
                                            <Form.Group className="mb-3" controlId="formContact">
                                                <Form.Label>Ph. No.</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="contact"
                                                    placeholder="Ph. No."
                                                    value={values.contact}
                                                    onChange={handleChange}
                                                    isInvalid={touched.contact && !!errors.contact}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.contact}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            {/* EMAIL */}
                                            <Form.Group className="mb-3" controlId="formEmail">
                                                <Form.Label>E-mail</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="email"
                                                    placeholder="E-mail ID"
                                                    value={values.email}
                                                    onChange={handleChange}
                                                    isInvalid={touched.email && !!errors.email}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.email}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            {/* MESSAGE */}
                                            <Form.Group className="mb-3" controlId="formMessage">
                                                <Form.Label>Message</Form.Label>
                                                <Form.Control
                                                    as="textarea"
                                                    rows={3}
                                                    name="msg"
                                                    placeholder="Your Thoughts"
                                                    value={values.msg}
                                                    onChange={handleChange}
                                                    isInvalid={touched.msg && !!errors.msg}
                                                />
                                                <Form.Control.Feedback type="invalid">
                                                    {errors.msg}
                                                </Form.Control.Feedback>
                                            </Form.Group>

                                            <Button variant="primary" type="submit">
                                                Submit
                                            </Button>
                                        </Form>
                                    )}
                                </Formik>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    );
};

export default Contact;
